export default function IsServeMode(): boolean {
    if(window.location.href.indexOf("localhost") > -1) {
        return true;
    }

    return false;
}